/** @format */

import { AfterContentInit, Directive, ElementRef, inject, output } from '@angular/core';

@Directive({
  selector: '[commonImagesLoaded]',
})
export class ImagesLoadedDirective implements AfterContentInit {
  public imagesLoaded = output<void>();

  private readonly element = inject(ElementRef);

  ngAfterContentInit() {
    const images = (this.element.nativeElement as HTMLElement).querySelectorAll('img');

    const loadPromises: Promise<void>[] = [];

    for (const image of Array.from(images)) {
      if (!image.complete) {
        loadPromises.push(
          new Promise<void>((res) => {
            image.addEventListener('load', () => {
              res();
            });
            image.addEventListener('error', () => {
              res();
            });
          }),
        );
      }
    }

    Promise.all(loadPromises).then(() => {
      this.imagesLoaded.emit();
    });
  }
}
